import React from "react";
import { Heart, Diamond, Sparkles, Church, PartyPopper, Coffee, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const INTENT_ICONS: Record<string, LucideIcon> = {
  flirting: Heart,
  serious: Diamond,
  elite: Sparkles,
  faith: Church,
  fun: PartyPopper,
  casual: Coffee,
};

export const INTENT_COLORS: Record<string, string> = {
  flirting: "from-pink-500 to-rose-500",
  serious: "from-purple-500 to-violet-500",
  elite: "from-amber-500 to-yellow-500",
  faith: "from-blue-500 to-cyan-500",
  fun: "from-green-500 to-emerald-500",
  casual: "from-orange-500 to-amber-500",
};

export const INTENT_LABELS: Record<string, string> = {
  flirting: "Flirting",
  serious: "Serious",
  elite: "Elite",
  faith: "Faith",
  fun: "Fun",
  casual: "Casual",
};

interface IntentBadgeProps {
  intent: string;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

const IntentIcon: React.FC<IntentBadgeProps> = ({
  intent,
  size = "md",
  showLabel = true,
  className,
}) => {
  const Icon = INTENT_ICONS[intent] || Heart;
  const colorClass = INTENT_COLORS[intent] || INTENT_COLORS.casual;
  const label = INTENT_LABELS[intent] || intent;

  const sizeClasses = {
    sm: "text-[10px] px-1.5 py-0.5",
    md: "text-xs px-2 py-0.5",
    lg: "text-sm px-3 py-1",
  };

  const iconSizes = {
    sm: "w-2.5 h-2.5",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-full text-white font-semibold bg-gradient-to-r",
        colorClass,
        sizeClasses[size],
        className
      )}
    >
      <Icon className={cn(iconSizes[size], "shrink-0")} />
      {showLabel && <span>{label}</span>}
    </div>
  );
};

export default IntentIcon;
